import { useState } from 'react';

export const useWidthState = () => useState({ isFullWidth: false, isDoubleColumn: false });
export type WidthStateProps = ReturnType<typeof useWidthState>;
